// removed by extract-text-webpack-plugin
module.exports = {"footer":"_1sKVcCYJJ_d3UvLayZTpkO","tablee":"_1MkXKIDHhALCTbt5MiBWLQ","col":"_2ua90Ti8Iun90fISaWcAlN"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ProductPreselection/ProductPreselection.scss
 ** module id = 1091
 ** module chunks = 0
 **/